import { CSSProperties } from 'react';

export const styles: Record<string, CSSProperties> = {
  page: {
    minHeight: '100vh',
    background: 'var(--bg)',
  },
  logoutButton: {
    background: 'var(--surface)',
    border: '1px solid var(--border-strong)',
    color: 'var(--text)',
    padding: '8px 16px',
    borderRadius: '999px',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
  },
  demoButton: {
    background: 'var(--surface)',
    border: '1px solid var(--border-strong)',
    color: 'var(--text)',
    padding: '8px 16px',
    borderRadius: '999px',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'background 0.2s, color 0.2s',
  },
  main: {
    maxWidth: '1360px',
    margin: '0 auto',
    padding: '24px 32px',
  },
  layout: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    gap: '24px',
  },
  mainContent: {
    flex: '3 1 560px',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  hero: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
  },
  heroTitle: {
    fontFamily: 'var(--font-heading)',
    fontSize: '28px',
    fontWeight: 700,
    color: 'var(--text)',
    margin: 0,
  },
  heroSubtitle: {
    fontSize: '14px',
    color: 'var(--muted)',
    margin: '6px 0 0',
  },
  heroDescription: {
    fontSize: '14px',
    lineHeight: '1.5',
    color: 'var(--text-2)',
    margin: '8px 0 0',
    maxWidth: '560px',
  },
  addTimesButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '48px',
    padding: '0 24px',
    background: 'var(--mint)',
    color: '#0A0E0D',
    border: 'none',
    borderRadius: '12px',
    fontSize: '15px',
    fontWeight: 600,
    cursor: 'pointer',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
  },
  noFriendsCard: {
    background: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: '16px',
    padding: '32px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
  },
  noFriendsTitle: {
    fontFamily: 'var(--font-heading)',
    fontSize: '20px',
    fontWeight: 700,
    color: 'var(--text)',
    margin: 0,
  },
  noFriendsDescription: {
    fontSize: 14,
    lineHeight: 1.5,
    color: 'var(--text-2)',
    margin: 0,
    maxWidth: '400px',
  },
  communityLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    color: 'var(--mint)',
    fontSize: 14,
    fontWeight: 600,
    textDecoration: 'none',
    marginTop: 4,
  },
  inviteButton: {
    minHeight: '48px',
    padding: '0 24px',
    background: 'var(--mint)',
    color: '#0A0E0D',
    border: 'none',
    borderRadius: '12px',
    fontSize: '15px',
    fontWeight: 600,
    cursor: 'pointer',
  },
  comingSoonSection: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '12px',
    padding: '20px',
    background: 'var(--bg-bar)',
    border: '1px solid var(--border)',
    borderRadius: '12px',
  },
  comingSoon: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '8px',
    fontSize: '13px',
    color: 'var(--muted)',
  },
  comingSoonLabel: {
    fontSize: '13px',
    fontWeight: 600,
    color: 'var(--text-2)',
  },
  comingSoonPills: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
  },
  comingSoonPill: {
    padding: '6px 12px',
    borderRadius: '999px',
    border: '1px dashed var(--border-strong)',
    fontSize: '13px',
    color: 'var(--muted)',
    background: 'var(--surface)',
  },
  debugSection: {
    marginTop: '48px',
    paddingTop: '24px',
    borderTop: '1px solid var(--border)',
  },
  debugNote: {
    fontSize: '14px',
    color: 'var(--text-2)',
  },
};
